import { useEffect } from 'react';
import styled from '@emotion/styled';
import * as analysisState from '@/components/Analysis/state';
import { useSetAtom } from 'jotai';
import { urlToSVG } from '@/utils';
import { getCloudfrontUrl } from '@/utils/cloudfront';
import useFetchTemplatesByType from '@/hooks/useFetchTemplatesByType';
import { PointOfInterestTemplateTypeEnum } from '@/__generated__/graphql';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const DeckPlanDataLoader = ({ ...props }) => {
  const setPoiTemplateIcons = useSetAtom(analysisState.poiTemplateIcons);
  const setAllPointOfInterestTemplates = useSetAtom(analysisState.allPointOfInterestTemplates);
  const setAllVoiTemplates = useSetAtom(analysisState.allVoiTemplates);
  const { data } = useFetchTemplatesByType();

  useEffect(() => {
    const allTemplates = data?.allPointOfInterestTemplate;
    if (allTemplates) {
      const fetchData = async () => {
        const unresolvedSvgs = allTemplates?.map((template) => {
          return urlToSVG(getCloudfrontUrl(template?.icon?.name ?? ''));
        });

        try {
          const downloadedSvgs = await Promise.all(unresolvedSvgs);
          const svgData = allTemplates.map((template, index) => ({
            name: template.name,
            icon: downloadedSvgs[index],
            color: template.icon?.color ?? '',
          }));
          setPoiTemplateIcons(svgData);
        } catch (error) {
          console.log(error);
        }
      };
      setAllPointOfInterestTemplates(allTemplates);
      setAllVoiTemplates(
        allTemplates
          .filter((template) => template.type === PointOfInterestTemplateTypeEnum.VolumeOfInterest)
          .map((template) => template.name)
      );
      fetchData();
    }
  }, [
    setAllPointOfInterestTemplates,
    setPoiTemplateIcons,
    data?.allPointOfInterestTemplate,
    setAllVoiTemplates,
  ]);

  return <Wrapper {...props} />;
};
